import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SystemDtoKeysEnum } from '@zaoblako/shared/modules/system/enums/system-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';
import { booleanSchema } from '@zaoblako/shared/modules/serde/schemas/boolean.schema';

import * as yup from 'yup';

export interface ChangelogDescriptionBlockInterface {
  /** Optional identifier */
  id?: string;
  /** Optional order (0-based). If omitted, order in array is used. */
  sortOrder?: number;
  /** Block text (HTML supported, same as legacy description) */
  description: string;
  /** If true - visible for all tariffs */
  forAllTariffs: boolean;
  /** Module system names this block applies to (used only when forAllTariffs=false) */
  modules?: string[];
}

export const ChangelogDescriptionBlockDto = SerdeDtoClass.create<ChangelogDescriptionBlockInterface>(
  SystemDtoKeysEnum.CHANGELOG_DESCRIPTION_BLOCK_DTO,
  {
    id: {
      optional: true,
      label: 'ID',
      serializer: yup.string(),
    },
    sortOrder: {
      optional: true,
      label: 'Порядок',
      serializer: yup.number(),
    },
    description: {
      label: 'Описание',
      serializer: nonEmptyStringSchema,
    },
    forAllTariffs: {
      label: 'Для всех тарифов',
      serializer: booleanSchema,
    },
    modules: {
      optional: true,
      label: 'Модули',
      serializer: yup.array(yup.string()),
    },
  },
);

